import { render, staticRenderFns } from "./Notebooks.vue?vue&type=template&id=7fd989f0&scoped=true&"
import script from "./Notebooks.vue?vue&type=script&lang=js&"
export * from "./Notebooks.vue?vue&type=script&lang=js&"
import style0 from "./Notebooks.vue?vue&type=style&index=0&id=7fd989f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd989f0",
  null
  
)

component.options.__file = "Notebooks.vue"
export default component.exports